import { useState, useEffect } from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import axios from 'axios';
import qs from 'qs';
import ApexCharts from 'react-apexcharts';
import { addSpace } from '../components/Tools';


const Page7GraphsParHypothese = (props) =>
{

    const blue = '#069BD3';
    const height = props.height || 800;
    const width = props.width || 1200;
    const fontsize = (height*12/890);
    const sizelogo = width/6;

    const [graph1Series, setGraph1Series] = useState(undefined);
    const [graph1Options, setGraph1Options] = useState(undefined);
    const [graph2Series, setGraph2Series] = useState(undefined);
    const [graph2Options, setGraph2Options] = useState(undefined);

    useEffect(() => {
        fetchCapitalStockeByModality();
        fetchCapitalStockeByAxeIntervention();
    }, [props.hypothese]);

    const fetchCapitalStockeByModality = () => {

        if (!props.user?.id_budget) {
            return;
        }

        if (!props.hypothese) {
            return;
        }

        // Convertir le numéro hypothèse (1,2,3) en h1, h2, h3
        const hypotheseKey = `h${props.hypothese}`;

        const params = {
            capitalStockeByModalityOfPortage: true,
            id_budget: props.user.id_budget,
            hypothese: hypotheseKey
        };

        axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify(params))
        .then(response => {
            if (response.data.status === 1) {
                const data = response.data.data;
                
                const modalites = data.map(item => item.modalite);
                
                const values = data.map(item => item.capital_stocke);

                // Palette de couleurs
                const colors = [
                    '#069BD3', '#59B44A', '#6571FE', '#FF6B6B', '#FFA500',
                    '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD',
                    '#20B2AA', '#FFB6C1', '#87CEEB', '#F0E68C', '#FF69B4'
                ];

                // Générer des couleurs pour chaque modalité
                const barColors = modalites.map((_, index) => colors[index % colors.length]);

                const options = {
                    chart: {
                        type: 'bar',
                        height: props.height * 0.7,
                        toolbar: {
                            show: false
                        }
                    },
                    title: {
                        text: 'Capital Stocké par Modalité de Portage',
                        style: {
                            fontSize: fontsize + 4
                        }
                    },
                    xaxis: {
                        categories: modalites,
                        labels: {
                            show: false,
                            style: {
                                fontSize: fontsize
                            }
                        }
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return addSpace(Math.round(value*100)/100, true) + " €";
                            },
                            style: {
                                fontSize: fontsize
                            }
                        }
                    },
                    dataLabels: {
                        formatter: (val) => {
                            return addSpace(Math.round(val/1000), true) + "k€";
                        },
                        style: {
                            fontSize: fontsize - 2
                        }
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            distributed: true
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    colors: barColors
                };

                const series = [{
                    name: 'Capital Stocké',
                    data: values
                }];

                setGraph1Options(options);
                setGraph1Series(series);
            }
        })
        .catch(error => {
            if (error.response) {
                console.error('Erreur status:', error.response.status);
                console.error('Erreur data:', error.response.data);
            }
        });
    };

    const fetchCapitalStockeByAxeIntervention = () => {

        if (!props.user?.id_budget) {
            return;
        }

        if (!props.hypothese) {
            return;
        }

        // Convertir le numéro hypothèse (1,2,3) en h1, h2, h3
        const hypotheseKey = `h${props.hypothese}`;

        const params = {
            capitalStockeByAxeIntervention: true,
            id_budget: props.user.id_budget,
            hypothese: hypotheseKey
        };

        axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify(params))
        .then(response => {
            if (response.data.status === 1) {
                const data = response.data.data;
                
                const axes = data.map(item => item.axe);
                const values = data.map(item => item.capital_stocke);

                // Palette de couleurs différente pour le graphique 2 (moins flashy)
                const colors = [
                    '#9BACBD', '#B8D8B8', '#D9A67C', '#C9A9D8', '#A8D8EA',
                    '#D8A5C0', '#D4C8B8', '#A9A9A9', '#8BA4B8', '#A8C586',
                    '#B4C7E7', '#C4A7A7', '#A8D5A8', '#D0B8D0', '#C9B89F'
                ];

                // Générer des couleurs pour chaque axe
                const barColors = axes.map((_, index) => colors[index % colors.length]);

                const options = {
                    chart: {
                        type: 'bar',
                        height: props.height * 0.7,
                        toolbar: {
                            show: false
                        }
                    },
                    title: {
                        text: 'Capital Stocké par Axe d\'Intervention',
                        style: {
                            fontSize: fontsize + 4
                        }
                    },
                    xaxis: {
                        categories: axes,
                        labels: {
                            show: false,
                            style: {
                                fontSize: fontsize
                            }
                        }
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return addSpace(Math.round(value*100)/100, true) + " €";
                            },
                            style: {
                                fontSize: fontsize
                            }
                        }
                    },
                    dataLabels: {
                        formatter: (val) => {
                            return addSpace(Math.round(val/1000), true) + "k€";
                        },
                        style: {
                            fontSize: fontsize - 2
                        }
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            distributed: true
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    colors: barColors
                };

                const series = [{
                    name: 'Capital Stocké',
                    data: values
                }];

                setGraph2Options(options);
                setGraph2Series(series);
            }
        })
        .catch(error => {
            if (error.response) {
                console.error('Erreur status Graph 2:', error.response.status);
                console.error('Erreur data Graph 2:', error.response.data);
            }
        });
    };

    return (
        <div style={{width: '100%', height: '100%', padding: 20}}>

            {/* Header */}
            <div style={{display: 'flex', height: '15%'}}>
                <div style={{flex: 0.4, display: 'flex', marginLeft: 10}}>
                {props.logo && (
                    <img style={{maxHeight: height/8, borderRadius: 5}} src={props.logo} alt="Logo" />
                )}
                </div>

                <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: blue, fontSize: (fontsize+10)}}>Graphiques</p>
                    <p style={{color: blue, fontSize: (fontsize+6), marginLeft: 5, fontStyle: 'italic'}}>{props.hypothese !== null ? '(hypothèse '+props.hypothese+')' : ''}</p>
                </div>

                <div style={{flex: 0.4, display: 'flex', justifyContent: 'right', marginRight: 25}}>
                    <p style={{color: 'grey', fontSize: (fontsize+4)}}>Synthèse globale des opérations</p>
                </div>
            </div>


            {/* Container */}
            <div style={{flex: 1, height: '80%', fontSize: fontsize, overflowY: 'hidden', overflowX: 'hidden', paddingLeft: '20px', paddingRight: '20px', display: 'flex', gap: '20px'}}>
                
                {/* Graphique 1 - Capital Stocké par Modalité */}
                <div style={{flex: 1, border: '1px solid #ccc', borderRadius: '5px', padding: '10px'}}>
                    {graph1Options && graph1Series ? (
                        <ApexCharts
                            series={graph1Series}
                            options={graph1Options}
                            type="bar"
                            height={Math.max(300, height * 0.7)}
                        />
                    ) : (
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column'}}>
                            <p style={{color: '#999', fontSize: fontsize}}>Chargement...</p>
                        </div>
                    )}
                </div>

                {/* Graphique 2 - Capital Stocké par Axe d'Intervention */}
                <div style={{flex: 1, border: '1px solid #ccc', borderRadius: '5px', padding: '10px'}}>
                    {graph2Options && graph2Series ? (
                        <ApexCharts
                            series={graph2Series}
                            options={graph2Options}
                            type="bar"
                            height={Math.max(300, height * 0.7)}
                        />
                    ) : (
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column'}}>
                            <p style={{color: '#999', fontSize: fontsize}}>Chargement...</p>
                        </div>
                    )}
                </div>
                
            </div>
            
                        
            {/* Footer */}
            <div style={{display: 'flex', height: '5%', position: 'relative'}}>
                <div style={{position: 'absolute', bottom: 0, display: 'flex', marginLeft: 25, alignItems: 'center', width: 200}}>
                    <p style={{fontSize: (fontsize-2)}}>{props.date}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, left: '47%', display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{fontSize: fontsize}}>page : {props.pagination} / {props.countPageTotal}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, right: 0, display: 'flex', marginRight: 25, alignItems: 'center'}}>
                    <img style={{width: sizelogo}} src={Logo} />
                </div>
            </div>
            
        </div>
    );
}
  
  export default Page7GraphsParHypothese;
